import React, { useMemo, useState } from 'react';
import { Paper, Typography } from '@material-ui/core';
import useVideoContext from '../../hooks/useVideoContext/useVideoContext';
import { LocalAudioTrack } from 'twilio-video';
import useVisperHttpTranscription from '../../hooks/useVisperHttpTranscription/useVisperHttpTranscription';

export default function TranscriptionPanel() {
  const { localTracks } = useVideoContext();
  const audioTrack = useMemo(() => localTracks.find(t => t.kind === 'audio') as LocalAudioTrack | undefined, [
    localTracks,
  ]);

  const [partial, setPartial] = useState('');
  const [finals, setFinals] = useState<string[]>([]);

  const participantName = 'John Doe'; // replace with dynamic value if available

  const { error } = useVisperHttpTranscription(
    audioTrack,
    (text: string) => {
      if (text && text.endsWith('\n')) {
        setFinals(prev => [...prev, text.trim()]);
        setPartial('');
      } else if (text) {
        setPartial(text);
      }
    },
    participantName //pass participant name to the hook
  );

  return (
    <Paper style={{ padding: 12, maxHeight: 200, overflow: 'auto' }}>
      <Typography variant="subtitle2" style={{ marginBottom: 8 }}>
        Live Transcript
      </Typography>

      {finals.map((t, i) => (
        <Typography key={i} variant="body2" style={{ opacity: 0.9 }}>
          {t}
        </Typography>
      ))}

      {partial && (
        <Typography variant="body2" style={{ opacity: 0.6 }}>
          {partial}
        </Typography>
      )}

      {error && (
        <Typography color="error" variant="caption">
          {error}
        </Typography>
      )}
    </Paper>
  );
}
